import style from './Banner.module.css';
import { Styled } from './Styled';

interface IBanner {
    srcDeskImg: string;
    srcMobileImg: string;
    name?: string;
}

export const Banner = ( props: IBanner ) => {
    return (
        <Styled.Content>
            <img src={props.srcDeskImg} alt={props.name || "Banner Desktop"} />    
            <img src={props.srcMobileImg} alt={props.name || "Banner Mobile"} />   
        </Styled.Content>
    );
}